import {post} from 'aws-amplify/api';
import type {DocumentType} from '@aws-amplify/core/internals/utils';
import {Command, type PostMethod} from '../../Command';
import type {UpdateMeResponse} from '../../../dto/user/UpdateMeResponse';

export interface UpdateMeInput {
  firstname?: string;
  lastname?: string;
  locale?: 'de' | 'en' | 'es' | 'fr' | 'it' | 'pt';
  email?: string;
  defaultPublishTime?: string; // Format "HH:mm"
  appearanceMode?: 'dark' | 'light' | 'system';
  autoSaveDraftsEnabled?: boolean;
  shortUrl?: string;
}

export class UpdateMeCommand extends Command<PostMethod, UpdateMeResponse> {
  constructor({
    firstname,
    lastname,
    locale,
    email,
    defaultPublishTime,
    appearanceMode,
    autoSaveDraftsEnabled,
    shortUrl,
  }: UpdateMeInput) {
    const postBody: DocumentType = {};
    if (firstname !== undefined) {
      postBody.firstname = firstname;
    }
    if (lastname !== undefined) {
      postBody.lastname = lastname;
    }
    if (locale !== undefined) {
      postBody.locale = locale;
    }
    if (email !== undefined) {
      postBody.email = email;
    }
    if (defaultPublishTime !== undefined) {
      postBody.defaultPublishTime = defaultPublishTime;
    }
    if (appearanceMode !== undefined) {
      postBody.appearanceMode = appearanceMode;
    }
    if (autoSaveDraftsEnabled !== undefined) {
      postBody.autoSaveDraftsEnabled = autoSaveDraftsEnabled;
    }
    if (shortUrl !== undefined) {
      postBody.shortUrl = shortUrl;
    }
    super(post, {
      path: '/me',
      options: {
        body: postBody,
      },
    });
  }

  async deserialize(output: ReturnType<typeof post>): Promise<UpdateMeResponse> {
    const {body} = await output.response;
    return await (body.json() as unknown as Promise<UpdateMeResponse>);
  }
}
